<button
  class="w-10 lg:w-16 p-1 lg:p-2 flex flex-col justify-center items-center gap-1 text-black dark:text-white transition-all transform duration-200"
  (click)="onSelectSidebar(0)"
  [ngClass]="{
    'bg-none text-gray-800 ': selectedSidebarIndex !== 0,
    'bg-gray-800 text-white': selectedSidebarIndex === 0,
  }"
>
  <svg
    class="w-5 h-5 lg:w-6 lg:h-6 flex-none"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
  </svg>
  <span class="text-xs">Project Select</span>
</button>
<button
  class="w-10 lg:w-16 p-1 lg:p-2 flex flex-col justify-center items-center gap-1 text-black dark:text-white transition-all transform duration-200"
  (click)="onSelectSidebar(1)"
  [ngClass]="{
    'bg-none text-gray-800': selectedSidebarIndex !== 1,
    'bg-gray-800 text-white': selectedSidebarIndex === 1,
  }"
>
  <svg
    class="w-5 h-5 lg:w-6 lg:h-6 flex-none"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
  </svg>
  <span class="text-xs">Color</span>
</button>
<button
  class="w-10 lg:w-16 p-1 lg:p-2 flex flex-col justify-center items-center gap-1 text-black dark:text-white transition-all transform duration-200"
  (click)="onSelectSidebar(2)"
  [ngClass]="{
    'bg-none text-gray-800': selectedSidebarIndex !== 2,
    'bg-gray-800 text-white': selectedSidebarIndex === 2,
  }"
>
  <svg
    class="w-5 h-5 lg:w-6 lg:h-6 flex-none"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
  </svg>
  <span class="text-xs">Part</span>
</button>
<button
  class="w-10 lg:w-16 p-1 lg:p-2 flex flex-col justify-center items-center gap-1 text-black dark:text-white transition-all transform duration-200"
  (click)="onSelectSidebar(3)"
  [ngClass]="{
    'bg-none text-gray-800': selectedSidebarIndex !== 3,
    'bg-gray-800 text-white': selectedSidebarIndex === 3,
  }"
>
  <svg
    class="w-5 h-5 lg:w-6 lg:h-6 flex-none"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
  </svg>
  <span class="text-xs">Preset</span>
</button>
<button
  class="w-10 lg:w-16 p-1 lg:p-2 flex flex-col justify-center items-center gap-1 text-black dark:text-white transition-all transform duration-200"
  (click)="onSelectSidebar(4)"
  [ngClass]="{
    'bg-none text-gray-800': selectedSidebarIndex !== 4,
    'bg-gray-800 text-white': selectedSidebarIndex === 4,
  }"
>
  <svg
    class="w-5 h-5 lg:w-6 lg:h-6 flex-none"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
  </svg>
  <span class="text-xs">Share</span>
</button>
